import { eventChannel } from 'redux-saga';
import { put, take } from 'redux-saga/effects';

import { subscribeToOidcSessionRefresh } from '../auth/session';

// Both apps decode the token into `state.auth` on this action (userId, exp, …).
// It is put by type string, like APP/FLUSH, because the action creators live in
// the app packages.
export const SET_ACCESS_TOKEN_ACTION_TYPE = 'AUTH/SET_ACCESS_TOKEN';

const createRefreshChannel = () =>
  eventChannel((emit) => subscribeToOidcSessionRefresh(emit));

/**
 * An /oidc refresh happens inside apiFetch, below the store. Mirror every new
 * access token into redux so `state.auth.accessToken` / `exp` stay current
 * (the web idle timer reads `exp`; impersonation re-reads the token's flags).
 */
export function* forwardOidcSessionRefreshes() {
  const channel = createRefreshChannel();
  try {
    while (true) {
      const { accessToken } = yield take(channel);
      if (accessToken) {
        yield put({ type: SET_ACCESS_TOKEN_ACTION_TYPE, payload: accessToken });
      }
    }
  } finally {
    channel.close();
  }
}

export const oidcSessionSagas = [forwardOidcSessionRefreshes];
